import {
  ActionBar,
  AppointmentCard,
  ChakraFlex,
  EmptySectionCard,
  FAIconName,
  SkeletonLoader,
} from '@equip.health/ui';
import { getAppointmentCardDisplayProps } from '~/lib/util/appointment.util';
import {
  LastJoinedAppointmentResponse,
  useGetLastJoinedAppointmentQuery,
} from '~/store/services/appointment';

const getLastAttendedCardProps = (
  appointment: LastJoinedAppointmentResponse,
) => ({
  ...getAppointmentCardDisplayProps({
    appointmentExternalId: appointment.appointmentExternalId,
    appointmentStartDateTime: appointment.appointmentStartDateTime,
    host: appointment.host,
    id: `last-attended-session--${appointment.appointmentExternalId}`,
    title: appointment.subject || appointment.appointmentTypeLabel,
  }),
  menuOptions: [],
});

const LastAttendedSessionSectionCard = ({
  patientId,
}: {
  patientId?: string;
}) => {
  const {
    data: appointment,
    isError,
    isLoading,
  } = useGetLastJoinedAppointmentQuery(patientId ?? '', {
    skip: !patientId,
  });

  if (isError) {
    return (
      <ActionBar
        barIcon={FAIconName.exclamationTriangleRegular}
        id="last-attended-session-error"
        text="We encountered an unexpected error loading the last attended session."
        variant="critical"
      />
    );
  }

  if (isLoading) {
    return (
      <SkeletonLoader id="last-attended-session-loading" isLoaded={false}>
        <ChakraFlex
          height="77px"
          id="last-attended-session-loading-placeholder"
          width="100%"
        />
      </SkeletonLoader>
    );
  }

  if (!appointment) {
    return (
      <EmptySectionCard
        caption="No sessions have been attended"
        id="last-attended-session-empty-state"
      />
    );
  }

  return <AppointmentCard {...getLastAttendedCardProps(appointment)} />;
};

export default LastAttendedSessionSectionCard;
